import { commonViewTexts } from '../common';

const targetName = commonViewTexts.user;

export const userListViewTexts = {
  title: `${targetName}一覧`,
  buttons: {
    create: `${targetName}登録`,
    edit: commonViewTexts.edit,
    delete: commonViewTexts.delete
  },
  searchBarPlaceholder: `${targetName}名`,
  header: {
    name: commonViewTexts.name,
    emailAddress: commonViewTexts.emailAddress,
    dateCreated: commonViewTexts.dateCreated,
    dateUpdated: commonViewTexts.dateUpdated
  }
} as const;
